import { AppState } from '@/vuex/store';
import { ScheduleEventParam } from '@/rule/models/ScheduleEventParam';
import { ScheduleRule, ScheduleRuleType } from '@/rule/models/ScheduleRule';
import { ScheduleDelay, DelayMode } from '@/rule/models/ScheduleDelay';
import { ScheduleMsg } from '@/rule/models/ScheduleMsg';
import scheduleRule from '@/rule/models/ScheduleRule';
import WxTemplate from '@/rule/models/WxTemplate';
import {
  EventTriggered,
  createEventTriggered,
  createPeriodic,
  createTimeFieldBased,
  PeriodicFreq,
} from '@/rule/models/ScheduleRuleContext';
import format from '@/customer/components/filter/makeCustomerQuery';

interface Params {
  key: string;
  value: any;
}

export default {
  UPDATE_TRENDS_DATA: (state: AppState, trendsData: any) => {
    state.scheduleRuleState.trendsData = trendsData;
  },
  UPDATE_SCHEDULE_EVENT_PARAMS: (state: AppState, params: ScheduleEventParam) => {
    const ruleState = state.scheduleRuleState;
    if (ruleState.scheduleRule) {
      ruleState.scheduleRule.ruleContext.EventTriggered.params  = params;
    }
  },
  INIT_EVENT_TRIGGERED: (state: AppState) => {
    const ruleState = state.scheduleRuleState;
    ruleState.scheduleRule.ruleType = ScheduleRuleType.Event;
    ruleState.scheduleRule.ruleContext = {
      EventTriggered: createEventTriggered(),
    };
  },
  INIT_PERIODIC: (state: AppState) => {
    const ruleState = state.scheduleRuleState;
    ruleState.scheduleRule.ruleType = ScheduleRuleType.Periodic;
    ruleState.scheduleRule.ruleContext = {
      Periodic: createPeriodic(),
    };
  },
  INIT_TIME_FIELD_BASED: (state: AppState) => {
    const ruleState = state.scheduleRuleState;
    if (ruleState.scheduleRule) {
      ruleState.scheduleRule.ruleType = ScheduleRuleType.TimeField;
      ruleState.scheduleRule.ruleContext = {
        TimeFieldBased: createTimeFieldBased(),
      };
    }
  },
  RESET_SCHEDULE_RULE: (state: AppState) => {
    state.scheduleRuleState.scheduleRule = JSON.parse(JSON.stringify(scheduleRule));
  },
  UPDATE_SCHEDULE_EVENT_TRIGGERED: (state: AppState, eventTriggered: EventTriggered) => {
    state.scheduleRuleState.scheduleRule.ruleContext.EventTriggered = eventTriggered;
  },
  UPDATE_SCHEDULE_DELAY: (state: AppState, delay: ScheduleDelay) => {
    state.scheduleRuleState.scheduleRule.ruleContext.EventTriggered.delay = delay;
  },
  UPDATE_SCHEDULE_RULE_NAME: (state: AppState, ruleName: string) => {
    state.scheduleRuleState.scheduleRule.ruleName = ruleName;
  },
  UPDATE_SCHEDULE_MSG: (state: AppState, msg: ScheduleMsg) => {
    state.scheduleRuleState.scheduleRule.scheduleMsg = msg;
  },
  UPDATE_EVENT_DELAY_MODE: (state: AppState, mode: DelayMode) => {
    state.scheduleRuleState.eventDelayMode = mode;
  },
  UPDATE_TIME_FIELD_BASED: (state: AppState, params: Params) => {
    state.scheduleRuleState.scheduleRule.ruleContext.TimeFieldBased[params.key] = params.value;
  },
  UPDATE_PERIODIC_FREQ: (state: AppState, freq: PeriodicFreq) => {
    state.scheduleRuleState.scheduleRule.ruleContext.Periodic.freq = freq;
  },
  SET_SCHEDULE_RULES: (state: AppState, rules: ScheduleRule[]) => {
    state.scheduleRuleState.scheduleRules = JSON.parse(JSON.stringify(rules));
  },
  UPDATE_SCHEDULE_RULE: (state: AppState, params: any) => {
    state.scheduleRuleState.scheduleRule = params.rule;
    if (params.rule.ruleContext.Periodic) {
      state.customerState.customerFilter = format.query2Filter(params.rule.ruleContext.Periodic.query, params.remarks);
    }
  },
  DELETE_SCHEDULE_RULE: (state: AppState, id: number) => {
    for (let i = 0; i < state.scheduleRuleState.scheduleRules.length; i++) {
      const prop = state.scheduleRuleState.scheduleRules[i];
      if (prop.id === id) {
        state.scheduleRuleState.scheduleRules.splice(i, 1);
      }
    }
  },
  UPDATE_WX_TEMPLATES: (state: AppState, wxTemplates: WxTemplate[]) => {
    state.scheduleRuleState.wxTemplates = wxTemplates;
  },
  SET_WX_TPL_TEMPLATES: (state: AppState, wxTplTemplates: any[]) => {
    state.scheduleRuleState.wxTplTemplates = wxTplTemplates;
  },
  ADD_WX_TPL_TEMPLATE: (state: AppState, wxTplTemplate: any) => {
    state.scheduleRuleState.wxTplTemplates.push(wxTplTemplate);
  },
  HIDE_WX_TPL_TEMPLATE_TIP: (state: AppState) => {
    state.scheduleRuleState.wxTplTemplateTip = false;
  },
  SHOW_WX_TPL_TEMPLATE_TIP: (state: AppState) => {
    state.scheduleRuleState.wxTplTemplateTip = true;
  },
  DELETE_WX_TPL_TEMPLATE: (state: AppState, id: number) => {
    for (let i = 0; i < state.scheduleRuleState.wxTplTemplates.length; i++) {
      const prop = state.scheduleRuleState.wxTplTemplates[i];
      if (prop.id === id) {
        state.scheduleRuleState.wxTplTemplates.splice(i, 1);
      }
    }
  },
};
